export const requestInfoType = {
  pending: "pending",
  skipped: "skipped",
  success: "success",
  error: "error",
};
